/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { keyframes, css }            from 'styled-components';
import { lighten }                   from 'polished';
import PropTypes                     from 'prop-types';
import { Colours, Spacing, Borders } from '../../../styles/variables';
import { RegularText }               from '../StyledTypography';
import { FormOutline }               from '../FormOutline';
import { Media }                     from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const sendingStateSize = '46px';

export const StyledButtonSubmit = RegularText.withComponent('button').extend`
  min-width: 100px;
  width: 100%;
  padding: ${Spacing.Tiny};
  color: ${Colours.White};
  background: ${Colours.Carnation};
  border-radius: ${Borders.Radius};
  border: 0;
  font-weight: 700;
  border: 1px solid transparent;
  ${props => !props.sending && css`
    &:focus {
      ${FormOutline(Colours.DodgerBlue)};
    }
    ${Media.Tablet`
      width: auto;
    `}
  `}
  ${props => props.sending && css`
    font-size: 0;
    outline: 0;
    width: ${sendingStateSize};
    height: ${sendingStateSize};
    min-width: auto;
    background: transparent;
    border-radius: ${sendingStateSize};
    border: 3px solid ${Colours.Alto};
    border-left-color: ${Colours.Carnation};
    animation: ${rotate} 700ms linear infinite;
  `}
  &:not(:disabled) {
    cursor: pointer;
  }
  &:disabled {
    background: ${lighten(0.05, Colours.Carnation)};
  }
`;

StyledButtonSubmit.propTypes = {
    sending: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/components/atoms/StyledButtonSubmit/index.js